export const rootRouteName = 'newHome';
export const accountTypeMap = {
    1: '主账号',
    2: '子账号'
};


// WEBPACK FOOTER //
// ./src/config/menuConfig.js